/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {QueryParams, QueryParamsHelper} from '../_helpers/query-params.helper';


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                                         OBSERVE TYPES                                                                              ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BODY = 'body';
export const RESPONSE = 'response';
export const EVENTS = 'events';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                                         RESPONSE TYPES                                                                             ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BLOB = 'blob';
export const JSON = 'json';


export abstract class AbstractService<T> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                         STATIC METHODS                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public static urlEncodeArray(key: string, values: any[]): string {
    return values.map((v: any, i: number) => `${key}[${i}]=${v}`).join('&');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  protected constructor(protected locale: string, protected httpClient: HttpClient, private sUrl: string, private mUrl: string) {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get baseUrl(): string {
    return `${environment.api.url}${this.locale}`;
  }

  get multipleUrl(): string {
    return `${this.baseUrl}/${this.mUrl}`;
  }

  get singleUrl(): string {
    return `${this.baseUrl}/${this.sUrl}`;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                GET                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public getById(id: number, qp?: QueryParams): Observable<HttpResponse<T>> {
    return this.httpClient.get<T>(`${this.singleUrl}/${id}`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  public find(qp?: QueryParams): Observable<HttpResponse<T[]>> {
    return this.httpClient.get<T[]>(`${this.multipleUrl}`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

}
